import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'room-list-search'

export interface RoomListSearchData {
  recentSearch: { id: string; type: 'USER' | 'ROOM' }[]
  recentUsers: { roomId: string; userId: string }[]
}

export const roomListSearchStorage = createKeyvalStorage<RoomListSearchData>(
  key,
)

export const roomListSearchView = createKeyvalView<RoomListSearchData>(key)
